import { generatePath } from 'react-router-dom'
import {
  PAYMENT_METHODS,
  PAYMENT_METHODS_CREATE,
  PAYMENT_METHODS_UPDATE,
  PAYMENT_METHOD_INFO,
  PAYMENT_METHODS_DESTROY,
} from 'constants/api-paths'
import request from './request'
import { formatError } from './error'

export const requestPaymentMethodsList = async () => (
  request.get(PAYMENT_METHODS)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestPaymentMethodUpdate = async (id, params) => {
  const path = generatePath(PAYMENT_METHODS_UPDATE, { id })
  return request.patch(path, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestPaymentMethodCreate = async (params) => (
  request.post(PAYMENT_METHODS_CREATE, params)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
)

export const requestPaymentMethodInfo = async (id) => {
  const path = generatePath(PAYMENT_METHOD_INFO, { id })
  return request.get(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}

export const requestPaymentMethodDestroy = async (id) => {
  const path = generatePath(PAYMENT_METHODS_DESTROY, { id })
  return request.delete(path)
    .then((resp) => resp.data)
    .catch((error) => formatError(error))
}
